import React, { useState } from 'react'
import './bodyElement.css'
import { Outlet, NavLink } from 'react-router-dom';
import DropDowwn from './drop-down/DropDowwn';
export default function BodyElement() {
    const [isOpen, setIsOpen] = useState(false)
    const openSidebar = () => {
        const sideBar = document.querySelector('.nav-item ul');
        sideBar.classList.toggle('on')
        setIsOpen(prev => !prev)
    }
    return (
        <div className='body-container'>
            <nav>
                <div className="nav-brand">
                    <NavLink to='/'><h2>FinFlex</h2></NavLink>
                </div>
                <div className="nav-item">
                    <ul>
                        <NavLink to="about"><li><p>About Us</p></li></NavLink>
                        <NavLink to="features">
                            <li className='feature'>
                                <p>Features</p>
                                <DropDowwn />
                                <i className='bx bx-chevron-down'></i>
                            </li>
                        </NavLink>
                        <NavLink to="how-it-works"><li><p>How It Works</p></li></NavLink>
                        <NavLink to="blog"><li><p>Blog</p></li></NavLink>
                    </ul>
                </div>
                <div className="aside">
                    <button><p>Join Waitlist</p></button>
                    {
                        isOpen
                            ? <i className='bx bx-x' onClick={openSidebar}></i>
                            : <i className='bx bx-menu' onClick={openSidebar}></i>
                    }
                </div>
            </nav>
            <main>
                <Outlet />
            </main>
        </div>
    )
}
